import { Component, OnInit } from '@angular/core';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services';
import { Http } from '@angular/http';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  constructor(private _service: NotificationsService,
    private advtService: AdvtService,
    private alertService: AlertService,
    private http: Http) { }
    public options = {
      position: ["top", "right"],
      lastOnBottom: false,
      preventDuplicates: true,
      timeout : 5000
    }
  public seller_id;
  pageSize = 10;
  pageNo = 1;
  loading: Boolean = true;
  mainLoader;
  user_id;
  ID;
  Merge_List;
  MergeListLength;
  allCategories;
  categoryId = 0;

  ngOnInit() {
    this.mainLoader = '../../assets/images/BigLoader.gif';

    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.user_id = userInfo.result.id;
    }
    this.advtService.getAllCategories().subscribe((data) => {
      this.allCategories = data;
    });
    
    this.mergePickup();
  }


  /**
* Function to get List
* @param seller_id
* @param category_id
*/
  public mergePickup() {
    this.loading = true;
    let params = {
      seller_id: this.user_id,
      limit: this.pageSize,
      offset: 0
    }

    this.advtService.mergePickupList(params)
      .subscribe(data => {

        this.Merge_List = data.result;
        this.MergeListLength = data.count;
        this.loading = false;
      }, error => {
        this.alertService.error(error);

      });
  }


  public _merchHistory() {
    this.loading = true;
    var params = {
      seller_id: this.user_id,
      limit: this.pageSize,
      offset: 0,
      category_id: this.categoryId
    };

    this.advtService.mergePickupList(params)
      .subscribe(data => {
        this.Merge_List = data.result;
        this.MergeListLength = data.count;
        this.loading = false;
      }, error => {
        this.alertService.error(error);
      });
  }

  /**
  * This function is used for pagination
  * @param data
  */
  pagingAgent(data) {
    this.loading = true;
    this.Merge_List = [];
    this.pageNo = (data * this.pageSize) - this.pageSize;

    let params = {
      seller_id: this.user_id,
      limit: this.pageSize,
      offset: this.pageNo
    }
    this.advtService.mergePickupList(params)
      .subscribe(data => {
        window.scrollTo(0, 0);
        this.Merge_List = data.result;
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/notification/notification.component.ts